// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/organizations/deactivations/firstparty/v3/create_downgrade.proto

/* oxlint-disable */

/** Status of the downgrade operation. */
export const ApiDowngradeStatus = {
  /**
   * DOWNGRADE_STATUS_UNSPECIFIED - Default unspecified status.
   */
  DOWNGRADE_STATUS_UNSPECIFIED: "DOWNGRADE_STATUS_UNSPECIFIED",
  /**
   * ongoing - The downgrade is ongoing.
   */
  ongoing: "ongoing",
  /**
   * completed - The downgrade is completed.
   */
  completed: "completed",
  /**
   * canceled - The downgrade is canceled.
   */
  canceled: "canceled",
} as const;

export type ApiDowngradeStatus = typeof ApiDowngradeStatus[keyof typeof ApiDowngradeStatus];

export namespace ApiDowngradeStatus {
  export type DOWNGRADE_STATUS_UNSPECIFIED = typeof ApiDowngradeStatus.DOWNGRADE_STATUS_UNSPECIFIED;
  export type ongoing = typeof ApiDowngradeStatus.ongoing;
  export type completed = typeof ApiDowngradeStatus.completed;
  export type canceled = typeof ApiDowngradeStatus.canceled;
}

export function apiDowngradeStatusFromJSON(object: any): ApiDowngradeStatus {
  switch (object) {
    case 0:
    case "DOWNGRADE_STATUS_UNSPECIFIED":
      return ApiDowngradeStatus.DOWNGRADE_STATUS_UNSPECIFIED;
    case 1:
    case "ongoing":
      return ApiDowngradeStatus.ongoing;
    case 2:
    case "completed":
      return ApiDowngradeStatus.completed;
    case 3:
    case "canceled":
      return ApiDowngradeStatus.canceled;
    default:
      return ApiDowngradeStatus.DOWNGRADE_STATUS_UNSPECIFIED;
  }
}

export function apiDowngradeStatusToJSON(object: ApiDowngradeStatus): string {
  switch (object) {
    case ApiDowngradeStatus.DOWNGRADE_STATUS_UNSPECIFIED:
      return "DOWNGRADE_STATUS_UNSPECIFIED";
    case ApiDowngradeStatus.ongoing:
      return "ongoing";
    case ApiDowngradeStatus.completed:
      return "completed";
    case ApiDowngradeStatus.canceled:
      return "canceled";
    default:
      return "DOWNGRADE_STATUS_UNSPECIFIED";
  }
}

/** Describes the request to create a downgrade for an organization with an active deactivation request. */
export interface ApiCreateDowngradeRequest {
  /** The organization ID (UUID format). */
  readonly organizationId: string;
}

/** Describes the response after creating a downgrade request. */
export interface ApiCreateDowngradeResponse {
  /** Status of the downgrade operation. */
  readonly status: ApiDowngradeStatus;
}

export const ApiCreateDowngradeRequest: MessageFns<ApiCreateDowngradeRequest> = {
  fromJSON(object: any): ApiCreateDowngradeRequest {
    return { organizationId: isSet(object.organization_id) ? globalThis.String(object.organization_id) : "" };
  },

  toJSON(message: ApiCreateDowngradeRequest): unknown {
    const obj: any = {};
    if (message.organizationId !== undefined && message.organizationId !== null) {
      obj.organization_id = message.organizationId;
    }
    return obj;
  },
};

export const ApiCreateDowngradeResponse: MessageFns<ApiCreateDowngradeResponse> = {
  fromJSON(object: any): ApiCreateDowngradeResponse {
    return {
      status: isSet(object.status)
        ? apiDowngradeStatusFromJSON(object.status)
        : ApiDowngradeStatus.DOWNGRADE_STATUS_UNSPECIFIED,
    };
  },

  toJSON(message: ApiCreateDowngradeResponse): unknown {
    const obj: any = {};
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiDowngradeStatusToJSON(message.status);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
